import { useContext, useEffect, useState } from 'react'
import { Resume } from './Candidate Portal/Account Tabs/Resume'
import { fetchCandidate } from '../services/Candidate Portal/Profile/fetchCandidateDetails'
import { DataProvider } from '../store/ContextProvider'

export default function ResumePopUp() {

    const { BeURL,currentUser } = useContext(DataProvider)
    const [setError] = useState("")
    const [candidate, setCandidate] = useState(null)
      const [setResume] = useState()
    


    const fetchCandidateData = () => fetchCandidate(BeURL, currentUser, setCandidate, setError)

    useEffect(() => {
        if (BeURL && currentUser?.role === "job-seeker") {
            fetchCandidateData()
        }
    }, [BeURL])

      const handleResumeData = (resume) => {
    setResume(resume)
  }
    return (
        <div className='fixed inset-0 z-50 bg-black/30 flex items-center justify-center  '>
            <Resume submitData={handleResumeData} _id={candidate._id} applicantID={candidate.applicantID} resumeAvailable={candidate.resumeAvailable} resumeLink={candidate.resumeLink} applicantName={candidate.applicantName} experience={candidate.experience} />
        </div>
    )
}
